// extracted by mini-css-extract-plugin
module.exports = {"slideshow":"D_b8","view":"D_cv","slide":"D_cb","img":"D_cw","btn":"D_bM","right":"D_cx","indicators":"D_cy","indicator":"D_cz","active":"D_cl"};